<template>
  <div class="table-page">
    <template v-if="tableId">
      <b-form-checkbox
        v-for="(field, index) in tableFields"
        :key="index"
        :value="field.key"
        v-model="showColumns"
        :disabled="showColumns.length === 1 && field.key === showColumns[0]"
        inline
        @change="hiddenShowColumns"
      >
        {{ field.label }}
      </b-form-checkbox>
    </template>

    <b-table
      bordered="bordered"
      show-empty="show-empty"
      small="small"
      :fields="visibleFields"
      :items="tableData"
      @sort-changed="changeSort"
      :no-local-sorting="isBackendSorting"
      :tbody-tr-class="customClass"
    >
      <template v-for="(slot4, name4) in cellScopesHeadTop" v-slot:[name4]="data4">
        <slot
          :name="name4"
          v-bind="data4"
        >
        </slot>
      </template>

      <template v-for="(slot2, name2) in cellScopesHead" v-slot:[name2]="data2">
        <slot
          :name="name2"
          v-bind="data2"
        >
        </slot>
      </template>

      <template v-for="(slot, name) in cellScopes" v-slot:[name]="data">
        <slot
          :name="name"
          v-bind="data"
        >
        </slot>
      </template>

      <template v-for="(slot3, name3) in cellScopesFoot" v-slot:[name3]="data3">
        <slot
          :name="name3"
          v-bind="data3"
        >
        </slot>
      </template>

      <template #empty>
        <div class="text-danger">沒有資料</div>
      </template>
    </b-table>

    <div v-if="pageData" ref="page_data" class="pagination-block">
      <div class="pagination-options-data">
        <div>共 {{ pageData.totalCount }} 筆</div>

        <div>
          <b-form-group
            label="筆數"
            label-cols-sm="5"
            label-align-sm="right"
            class="mt-3"
          >
            <b-form-select
              v-model="pageData.pageSize"
              id="tablePageOptions"
              size="sm"
              :options="pageData.page_options"
              @change="changePageResult(1)"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>

      <div class="pagination-items">
        <b-pagination
          v-model="pageData.pageIndex"
          :total-rows="pageData.totalCount"
          :per-page="pageData.pageSize"
          size="md"
          align="center"
          @change="changePageResult"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    tableData: {
      type: Array,
      required: true,
      default: () => []
    }, //表格資料
    tableFields: {
      type: Array,
      required: true,
      default: () => []
    }, //表格head
    pageData: {
      type: Object,
      required: false,
      default: () => {}
    }, //分頁資料
    isBackendSorting: { // 是否為後端排序
      type: Boolean,
      required: false,
      default: true
    },
    tableId: { // 表格ID，辨識各個頁面的表格，用來隱藏欄位作用
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      tableHeight: false,
      showColumns: [], // 用戶選擇隱藏的欄位
    }
  },
  computed: {
    cellScopesHead() {
      let entries = Object.keys(this.$scopedSlots).filter(name => name.startsWith('head')).map(name => [name, this.$scopedSlots[name]]);
      return Object.fromEntries(entries);
    },
    cellScopes() {
      let entries = Object.keys(this.$scopedSlots).filter(name => name.startsWith('cell')).map(name => [name, this.$scopedSlots[name]]);
      return Object.fromEntries(entries);
    },
    cellScopesFoot() {
      let entries = Object.keys(this.$scopedSlots).filter(name => name.startsWith('custom-foot')).map(name => [name, this.$scopedSlots[name]]);
      return Object.fromEntries(entries);
    },
    cellScopesHeadTop() {
      let entries = Object.keys(this.$scopedSlots).filter(name => name.startsWith('thead-top')).map(name => [name, this.$scopedSlots[name]]);
      return Object.fromEntries(entries);
    },
    visibleFields() {
      // 根據 showColumns 來篩選出應該顯示的欄位
      let table_Fields = [];

      if (this.tableId) table_Fields = this.tableFields.filter(field => this.showColumns.includes(field.key));
      else table_Fields = this.tableFields;

      return table_Fields;
    },
  },
  created() {
      this.initHiddenShowColumnsHandler();
  },
  methods:{
    //換頁
    changePageResult(page) {
      this.$emit('result', page);
    },
    //排序欄位
    changeSort(e) {
      let sort, sortBy;
      sortBy = e.sortBy;

      if (sortBy !== '') {
        e.sortDesc ? sort = 'desc' : sort = 'asc';
        this.$emit('result', null, sortBy, sort);
      }
    },
    customClass(rowData, rowIndex) {
      if (rowData) return rowData.body_tr_bg;
    },
    // 初始化隱藏或顯示 欄位資料處理
    initHiddenShowColumnsHandler() {
      const all_columns_key = this.tableFields.map(field => field.key);

      if (this.tableId) {
        try {
          const store_name = `${this.tableId}_show_columns`;
          const store_show_columns = JSON.parse(localStorage.getItem(store_name));

          if (store_show_columns && Array.isArray(store_show_columns) && store_show_columns.length > 0) {
            this.showColumns = store_show_columns;
          } else {
            this.showColumns = all_columns_key;
          }

        } catch (e) {
          this.showColumns = all_columns_key;
        }
      } else {
        this.showColumns = all_columns_key;
      }
    },
    // 隱藏或顯示 欄位
    hiddenShowColumns() {
      const store_name = `${this.tableId}_show_columns`;
      const store_key = JSON.stringify(this.showColumns);

      localStorage.setItem(store_name, store_key);
    }
  }
}
</script>
<style lang="scss">
.table-page{
  // overflow: auto;
   table{
    font-size:14px;
    thead{
      tr{
        th{
          background-color: #F5F6FA;
          text-align: center;
          vertical-align: middle;
        }
      }
    }
    tbody{
      tr{
        td{
          text-align: center;
          vertical-align: middle;
          max-width: 500px;
        }
      }
    }
  }
  .pagination-block {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    column-gap: 30px;
    .pagination-options-data {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 20px;
    }
    .pagination-items {
      ul.pagination  {
        margin-top: 12px;
        li {
          span {
            min-width: 40px;
            max-width: 100%;
          }
        }
        button {
          min-width: 40px;
          max-width: 100%;
        }
      }
    }
  }
}

.bg-normal {
  background: #FFFFFF;
}
.bg-fail {
  background: rgb(255, 255, 0);
}
.bg-died {
  background: rgb(255, 225, 255);
}
.bg-close {
  background: #f28500;
}
.bg-stop {
  background: rgb(211, 211, 211);
}
.bg-green {
  background: #d4edda;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/TablesPage.vue